export default "__VITE_ASSET__DFM8x3u9__"